import { ACCESS_TOKEN, REFRESH_TOKEN,EMAIL, KEYROCK_TOKEN ,PUBLICIP} from "../utils/constants";
import jwtDecode from "jwt-decode";
import moment from "moment";

export function getAccessTokenApi() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  if (!accessToken || accessToken === "undefined"||accessToken === undefined) {
    return null;
  }
  return  accessToken;
}

export function getEmail() {
  const email = localStorage.getItem(EMAIL);
  if (!email || email === "undefined"||email === undefined) {
    return null;
  } 
  return email;
}

export function getPublicIP() {
  const publicIP = localStorage.getItem(PUBLICIP);
  if (!publicIP || publicIP === "undefined") {
    return null;
  } 
  return publicIP;
}

export function getIdp() {
  const accessToken = localStorage.getItem(ACCESS_TOKEN);
  if (!accessToken || accessToken === "undefined") {
    return null;
  }
  return jwtDecode(accessToken).idp;
}

export function getKeyrockTokenApi() {
  const accessToken = localStorage.getItem(KEYROCK_TOKEN);
  if (!accessToken || accessToken === "undefined") {
    return null;
  }
  return accessToken;
}

export function getRefreshTokenApi() {
  const refreshToken = localStorage.getItem(REFRESH_TOKEN);
  if (!refreshToken || refreshToken === "undefined"||refreshToken === undefined) {
    return null;
  }
  return willExpireToken(refreshToken) ? null : refreshToken;
}

export function logout() {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(EMAIL);
  localStorage.removeItem(PUBLICIP); 
  localStorage.removeItem(KEYROCK_TOKEN);
}

export function willExpireToken(token) {
  const expirationTime = jwtDecode(token).exp;
  const currentTime = moment().unix();
  return currentTime >= expirationTime;
}


